// used in order not to trigger unhandled rejection error in JS console
export class AbortableRequestError extends Error {
  constructor(args) {
    super(args);
    this.name = 'AbortableRequestError';
  }
}

export const customApiErrors = {
  AbortableRequestError,
};
